// frontend/src/services/mlExperiment.service.ts

import api from './api';

const BASE_URL = '/ml';

export class MlExperimentService {

  static async listExperiments(): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/experiments`);
    return response.data.data;
  }

  static async getExperiment(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/experiment/${id}`);
    return response.data.data;
  }

  static async analyzeExperiment(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/experiment/analyze/${id}`);
    return response.data.data;
  }

  static async getExperimentsByTraceId(traceId: string): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/experiments/trace/${traceId}`);
    return response.data.data;
  }

  static async getExperimentsByDataset(datasetName: string): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/experiments/dataset/${datasetName}`);
    return response.data.data;
  }

  static async getSummary(datasetName?: string): Promise<any> {
    const url = datasetName
      ? `${BASE_URL}/summary?datasetName=${datasetName}`
      : `${BASE_URL}/summary`;
    const response = await api.get(url);
    return response.data.data;
  }

  static async compareVersions(datasetName?: string): Promise<any> {
    const url = datasetName
      ? `${BASE_URL}/compare?datasetName=${encodeURIComponent(datasetName)}`
      : `${BASE_URL}/compare`;
    const response = await api.get(url);
    return response.data.data;
  }

  static async promote(
    experimentPath: string,
    modelName: string,
    alias: string = 'production'
  ): Promise<any> {
    const response = await api.post('/ml-models/promote', {
      experiment_path: experimentPath,
      model_name: modelName,
      alias,
    });
    return response.data;
  }

  static async listProductionModels(): Promise<any[]> {
    const response = await api.get('/ml-models/models');
    return response.data.models || [];
  }
}